export default "__VITE_ASSET__de82fe27__"